import "../styles/scrollingFeedback.css";

export default function ScrollingFeedback() {
  return (
    <section className="feedback-section">
      <h2 className="feedback-title">What Learners Say</h2>

      <div className="feedback-marquee">
        <div className="feedback-track">

          <div className="feedback-card">
            <p>
              “This Gen AI program helped me understand LLMs practically.
              The RAG project was a game changer.”
            </p>
            <span>— Ankit, AI Developer</span>
          </div>

          <div className="feedback-card">
            <p>
              “The concepts were explained clearly and the hands-on projects
              boosted my confidence.”
            </p>
            <span>— Priya, Final Year Student</span>
          </div>

          <div className="feedback-card">
            <p>
              “Perfect course for beginners. Prompt engineering finally
              made sense to me.”
            </p>
            <span>— Rahul, Software Engineer</span>
          </div>

          <div className="feedback-card">
            <p>
              “Loved the real-world AI assistant project. Very industry-oriented.”
            </p>
            <span>— Sneha, Data Analyst</span>
          </div>

          {/* DUPLICATE FOR SMOOTH LOOP */}
          <div className="feedback-card">
            <p>
              “This Gen AI program helped me understand LLMs practically.”
            </p>
            <span>— Ankit, AI Developer</span>
          </div>

        </div>
      </div>
    </section>
  );
}
